import React from "react";
import AssetGrid from "./AssetGrid";

interface ProductShotsTabProps {
  assets: BrandAsset[];
  projectId: string;
  onUpload: (file: File) => Promise<void>;
  onDelete: (assetId: string) => void;
  onUpdate: (assetId: string, updates: FormData) => void;
}

const ProductShotsTab: React.FC<ProductShotsTabProps> = ({
  assets,
  projectId,
  onUpload,
  onDelete,
  onUpdate,
}) => {
  const productShots = assets.filter((a) => a.type === "product_shot_ref");

  return (
    <AssetGrid
      assets={productShots}
      assetType="product_shot_ref"
      onUpload={onUpload}
      onDelete={onDelete}
      onUpdate={onUpdate}
      emptyMessage="No product shot references yet. Upload images that show how your product is typically framed and lit."
    />
  );
};

export default ProductShotsTab;
